import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

export function useDateFormat() {
  
  return {
    formatDateTime: globalThis.formatDateTime,
    displayDateTime: globalThis.displayDateTime,
    displayDate: globalThis.displayDate,
    displayTime: globalThis.displayTime
  }

}


export function displayDate(date) {
  if (!date) return '';

  if (typeof date === 'string') {
    date = parseISO(date);
  }

  return format(date, "P", { locale: ptBR });
}